import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Col, Card, CardBody, Media } from 'reactstrap'
import moment from 'moment'
import { getExpedientStatus, getLastExpedientInput, getLastExpedientOutput } from '../../store/ducks/humanResources'

class ExpedientWidget extends Component {
  constructor(props) {
    super(props)
    this.state = {
      duration: 'Carregando...',
    }
  }

  componentDidMount() {
    const { getExpedientStatus, getLastExpedientInput, getLastExpedientOutput } = this.props

    getLastExpedientInput()
    getLastExpedientOutput()
    getExpedientStatus()

    this.interval = setInterval(() => {
      if (this.props.humanResources.lastExpedientInput) {
        const start = moment(this.props.humanResources.lastExpedientInput, 'HH:mm')
        const now = moment()
        const diff = now.diff(start)
        const duration = moment.utc(diff).format('HH[h]mm[min]')
        this.setState({ duration })
      } else {
        this.setState({ duration: null })
      }
    }, 1000)
  }

  componentWillUnmount() {
    if (this.interval) {
      clearInterval(this.interval)
    }
  }

  strToMins = (t) => {
    const s = t.split(':')
    return Number(s[0]) * 60 + Number(s[1])
  }

  minsToStr = (t) => {
    const hours = Math.trunc(t / 60)

    if (hours > 9) {
      return `${Math.trunc(t / 60)}:${(`00${t % 60}`).slice(-2)}`
    }
    return `0${Math.trunc(t / 60)}:${(`00${t % 60}`).slice(-2)}`
  }

  render() {
    const {
      getLastExpedientInputIsLoading, lastExpedientInput, lastExpedientOutput,
    } = this.props.humanResources

    const { duration } = this.state

    return (
      <>
        <Col md={4}>
          <Card>
            <CardBody>
              <Media>
                <Media body className="overflow-hidden">
                  <p className="text-truncate font-size-14 mb-2">
                    Expediente atual
                  </p>
                  <h4 className="mb-0">
                    {
                      getLastExpedientInputIsLoading ? (
                        'Carregando...'
                      ) : (
                        duration || 'Não iniciado'
                      )
                    }
                  </h4>
                </Media>
              </Media>
            </CardBody>
            <CardBody
              className="border-top"
              style={{
                paddingTop: 16,
                paddingBottom: 16,
                display: 'flex',
                justifyContent: 'space-between',
              }}
            >
              {lastExpedientOutput && !lastExpedientInput && (
                <span className="text-muted ml-1">
                  Saída:
                  {' '}
                  {(moment(lastExpedientOutput, 'DD/MM/YYYY h:mm').calendar()).toLowerCase()}
                </span>
              )}
              {lastExpedientInput && (
                <span className="text-muted ml-1">
                  Entrada:
                  {' '}
                  {(moment(lastExpedientInput, 'HH:mm').calendar()).toLowerCase()}
                </span>
              )}
            </CardBody>
          </Card>
        </Col>
      </>
    )
  }
}

const mapStateToProps = state => ({ humanResources: state.humanResources })
const mapDispatchToProps = dispatch => bindActionCreators({
  getExpedientStatus,
  getLastExpedientInput,
  getLastExpedientOutput,
}, dispatch)
export default connect(mapStateToProps, mapDispatchToProps)(ExpedientWidget)
